import { JSX } from "react";

export const FormatUsersUnderline3 = ({
  className,
  ...props
}: JSX.IntrinsicElements["svg"]) => {
  return (
    <svg
      viewBox="0 0 201 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M6 8C64.9136 2.50566 128.279 10.5462 195 6.25789"
        stroke="#CFB2FF"
        strokeWidth="12"
        strokeLinecap="round"
      />
    </svg>
  );
};
